export const modules = {
  push: false,
  operational_performance: false,
  enable_expanded_banner: false,
  raffle: false,
  products_tree: false,
  chatbot: false,
  offer_management: false,
  whatsapp: false,
  telesales: false,
  mobile: false,
  email_v2: false,
  points: false,
  cashback: false,
  uncategorized_products: false,
  forecast: false,
  advanced_discounts: false,
  products_category: false,
  dynamic_attributes: false,
  hotsite_international: false,
  industry: false,
  dynamic_sales: false,
  manage_products: false,
  jane: false,
  discount_coupon: false,
  offers_by_unit: false,
  pre_register: false,
  raffle_signed_terms: false,
  consumer_activation_after_sign_up: false,
  check_erp_offers: false,
  external_whatsapp_provider: false,
  ze_delivery: false,
  terms_optin: false,
  hotsite_management: false,
  raffle_segment_exclusion: false,
  use_erp_sales_as_offers_schedules: false,
  user_tags: false,
  offers_auto_distributed: false,
  whatsapp_page: false,
  combo_discount_by_count: false,
}
